export default {
    'alertsTitle.error': 'Error!',
    'alertsTitle.success': 'Success!',
    'alertsTitle.warning': 'Warning!',
    'alertsTitle.info': 'Info!',
  };
  